import {
  mapper
} from '@shared/lib';
import {
  type GameWinner
} from '../model';

type MapGameWinner = (data: any) => GameWinner;
export const mapGameWinner: MapGameWinner = mapper([
  { name: 'playerName', from: 'userId' },
  { name: 'gameId', from: 'gameID' },
  {
    name: 'amountWon',
    from: 'amount',
    transform: (amountWon: string) => {
      return Number(amountWon).toFixed(2);
    }
  },
  { name: 'currency' },
  { name: 'eventId' },
]);
